'use client'

import { ScoreBadgePopover } from '@/components/client/storyblok/article/score-badge-popover'
import { useTranslation } from '@/hooks/client/use-translation'

interface RowEvidenceProps {
  score: number | null
}

// Reuse the product-card badge and score explanation, with an explicit source
// beside it on desktop and a quiet label when no expert score is available.
export const RowEvidence = ({ score }: RowEvidenceProps) => {
  const { t } = useTranslation()

  if (score == null || score <= 0) {
    return (
      <span className="bg-navy/5 text-navy/70 inline-flex rounded-full px-2.5 py-1 text-[12px] font-medium whitespace-nowrap">
        {t('directory.row.notRated', 'Not yet rated')}
      </span>
    )
  }

  return (
    <div className="flex items-center gap-2.5">
      <ScoreBadgePopover score={score} variant="default" size="sm" placement="bottom" className="shadow-none" />
      <span className="text-navy/80 hidden text-[13px] leading-snug laptop:block">
        {t('directory.row.expertLabel', 'HearingTracker expert assessment')}
      </span>
    </div>
  )
}
